export default {
    isLoading: false
}